/** Visible public-site release version. Increment before every deployment. */
export const APP_VERSION = '0.1.24';
